import { z } from "zod";

export const ApiErrorBodySchema = z.object({
	code: z.number(),
	message: z.string(),
	details: z.record(z.unknown()).nullable(),
});
export type RequestError = z.infer<typeof ApiErrorBodySchema> & {
	http_status?: number;
};
